// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"350":"38475814","723":"4d566e36","787":"fa3c4679","968":"d4506c29"}[chunkId] + ".chunk.js";
};